/*
 * DRV mængderabat på antal-knapperne.
 * Beregner besparelsen pr. bundt (fx "3 stk.") ift. prisen pr. styk,
 * og viser "Spar X kr" over knappen og "Spar X%" under den (som inspirationen).
 */
(function () {
  function fmt(n) {
    // dansk tusindtalsseparator (punktum)
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Aflæser enheden i et variant-navn. Returnerer et sammenligneligt tal + type.
  // "3 stk." -> antal | "500 ml" / "1 liter" -> volumen (ml) | "250 g" / "1 kg" -> vægt (g).
  // VIGTIGT: ml tjekkes FØR liter, så "500 ml" ikke fejllæses som 500 liter.
  function parseUnits(opt) {
    var s = (opt || '').toLowerCase();
    var m;
    if ((m = s.match(/(\d+(?:[.,]\d+)?)\s*(?:stk\.?|styk|pak|par)/))) return { n: parseFloat(m[1].replace(',', '.')), type: 'stk' };
    if ((m = s.match(/(\d+(?:[.,]\d+)?)\s*ml\b/))) return { n: parseFloat(m[1].replace(',', '.')), type: 'ml' };
    if ((m = s.match(/(\d+(?:[.,]\d+)?)\s*(?:liter|ltr|l)\b/))) return { n: parseFloat(m[1].replace(',', '.')) * 1000, type: 'ml' };
    if ((m = s.match(/(\d+(?:[.,]\d+)?)\s*kg\b/))) return { n: parseFloat(m[1].replace(',', '.')) * 1000, type: 'g' };
    if ((m = s.match(/(\d+(?:[.,]\d+)?)\s*g\b/))) return { n: parseFloat(m[1].replace(',', '.')), type: 'g' };
    return { n: null, type: null };
  }

  function init() {
    var dataEl = document.getElementById('drv-bundle-data');
    if (!dataEl) return;
    var variants;
    try { variants = (JSON.parse(dataEl.textContent).variants) || []; }
    catch (e) { return; }

    var parsed = variants.map(function (v) {
      var u = parseUnits(v.opt);
      return { opt: v.opt, units: u.n, type: u.type, price: v.price };
    }).filter(function (v) { return typeof v.price === 'number'; });
    if (!parsed.length) return;

    // Besparelse beregnes KUN hvis alle varianter har samme, genkendelige enhed,
    // så pris pr. enhed kan sammenlignes. Ellers ingen "Spar"-tekst (undgår fejl som
    // "spar 100%" når tallet i navnet er en størrelse, fx 500 ml vs 1 liter).
    var firstType = parsed[0].type;
    var comparable = parsed.length > 1 &&
      parsed.every(function (v) { return v.type === firstType && v.units > 0; });

    var byOpt = {};
    if (comparable) {
      // Reference = den DYRESTE pris pr. enhed (typisk mindste størrelse / 1 stk.).
      // De billigere-pr-enhed varianter (fx 1 liter) viser så den reelle besparelse.
      var ref = Math.max.apply(null, parsed.map(function (v) { return v.price / v.units; }));
      parsed.forEach(function (v) {
        var full = ref * v.units;
        var save = full - v.price;
        byOpt[v.opt] = {
          saveKr: Math.round(save / 100),
          pct: full > 0 ? Math.round((save / full) * 100) : 0
        };
      });
    } else {
      parsed.forEach(function (v) { byOpt[v.opt] = { saveKr: 0, pct: 0 }; });
    }

    var fieldset = document.querySelector('.drv-buybox .product-form__input--pill');
    if (!fieldset || fieldset.dataset.drvBundle) return;
    fieldset.dataset.drvBundle = '1';
    fieldset.dataset.drvUnitType = firstType || '';
    fieldset.classList.add('drv-bundle');

    var inputs = fieldset.querySelectorAll('input[type="radio"]');
    Array.prototype.forEach.call(inputs, function (input) {
      var label = fieldset.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var info = byOpt[input.value];

      var cell = document.createElement('div');
      cell.className = 'drv-variant-cell';
      var top = document.createElement('div');
      top.className = 'drv-save-top';
      var bar = document.createElement('div');
      bar.className = 'drv-var-bar';
      var bot = document.createElement('div');
      bot.className = 'drv-save-bot';

      if (info && info.saveKr > 0) {
        top.textContent = 'Spar ' + fmt(info.saveKr) + ' kr';
        bot.textContent = 'Spar ' + info.pct + '%';
        cell.classList.add('has-save');
      } else {
        top.innerHTML = '&nbsp;';
        bot.innerHTML = '&nbsp;';
      }

      input.parentNode.insertBefore(cell, input);
      cell.appendChild(top);
      cell.appendChild(bar);
      cell.appendChild(input);
      cell.appendChild(label);
      cell.appendChild(bot);
    });
    updateSelected();
  }

  // Marker den valgte mængde (til bjælke + boks-styling)
  function updateSelected() {
    var fieldset = document.querySelector('.drv-buybox .product-form__input--pill');
    if (!fieldset) return;
    var cells = fieldset.querySelectorAll('.drv-variant-cell');
    Array.prototype.forEach.call(cells, function (c) {
      var inp = c.querySelector('input[type="radio"]');
      c.classList.toggle('is-selected', !!(inp && inp.checked));
    });
  }

  // Dynamisk "Antal: X stk."-label (som inspirationen)
  function updateLegend() {
    var fieldset = document.querySelector('.drv-buybox .product-form__input--pill');
    if (!fieldset) return;
    var legend = fieldset.querySelector('legend');
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (legend && checked) {
      var t = fieldset.dataset.drvUnitType;
      var label = t === 'stk' ? 'Antal' : (t === 'ml' || t === 'g' ? 'Størrelse' : 'Valg');
      legend.textContent = label + ': ' + checked.value.replace(/\s+/g, ' ').trim();
    }
  }

  function boot() { init(); updateLegend(); }

  // Temaet gen-renderer variant-vælgeren, når man vælger en mængde (opdaterer pris/lager),
  // hvilket sletter vores bjælker. Denne vagt genopbygger dem automatisk.
  var rebuildScheduled = false;
  var observer = new MutationObserver(function () {
    if (rebuildScheduled) return;
    var fs = document.querySelector('.drv-buybox .product-form__input--pill');
    if (fs && !fs.dataset.drvBundle) {
      rebuildScheduled = true;
      setTimeout(function () { rebuildScheduled = false; boot(); }, 40);
    }
  });
  function startObserving() {
    var target = document.querySelector('.product__info-container') || document.body;
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  function bootAll() { boot(); startObserving(); }

  if (document.readyState !== 'loading') { bootAll(); }
  else { document.addEventListener('DOMContentLoaded', bootAll); }
  document.addEventListener('shopify:section:load', bootAll);
  // Opdater label + markering når kunden vælger en anden mængde
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.drv-buybox .product-form__input--pill input[type="radio"]')) {
      updateLegend();
      updateSelected();
    }
  });
})();

